import BundleVersionList from './BundleVersionList';

export default BundleVersionList;
